<div class="modal-dialog change-password-dialog-container">
	<div class="modal-content" cdkTrapFocus>
		<form (ngSubmit)="submit(form)" [formGroup]="form">
			<div class="goreact-modal-header">
				<h4 class="modal-title"
					translate="{{ data.isUnlinking ? 'unlink-sso-dialog_title' : 'modal-change-password_change-password' }}"
					[translateParams]="{provider: data.authProvider?.open_id_configuration.display_name}">
				</h4>
				<button type="button" class="close-btn" (click)="close()" [attr.aria-label]="'common_close'| translate">
					<i class="ficon-app-x"></i>
				</button>
			</div>
			<div class="goreact-modal-body">
				@if (data.isUnlinking) {
					<p translate="modal-change-password_unlink-sso" [translateParams]="{provider: data.authProvider?.open_id_configuration.display_name}"></p>
				}
				@if (shouldShowOldPasswordField()) {
					<mat-form-field appearance="outline" class="old-password" goPasswordVisibilityToggle>
						<mat-label translate="modal-change-password_old-password"></mat-label>
						<input type="password" matInput formControlName="oldPassword" class="fullstory-ignore old-password-input" />
						@if (form.controls.oldPassword.hasError('required')) {
							<mat-error translate="modal-change-password_error-enter-old-password"></mat-error>
						}
					</mat-form-field>
				}

				<mat-form-field appearance="outline"
					class="new-password"
					goPasswordVisibilityToggle>
					<mat-label translate="modal-change-password_new-password"></mat-label>
					<input type="password" matInput formControlName="newPassword" class="fullstory-ignore new-password-input" />
					<button
						mat-icon-button
						matIconSuffix
						[matTooltip]="'sign-up-password-rules' | translate">
						<mat-icon
							class="ficon-app-help-circle-outline">
						</mat-icon>
					</button>
					@if (form.controls.newPassword.invalid) {
						<mat-error translate="common_password_error-password-requirements"></mat-error>
					}
				</mat-form-field>
			</div>
			<div class="goreact-modal-footer">
				@if (error) {
					<span class="error-text">{{ error }}</span>
				}
				<button
					type="button"
					class="cancel-btn tertiary-btn"
					(click)="close()"
					[attr.aria-label]="'common_cancel'| translate">
					{{'common_cancel' | translate}}
				</button>
				<button
					type="submit"
					class="primary-btn submit-btn"
					[attr.aria-label]="'modal-change-password_change-password' | translate"
					[disabled]="(loading$ | async)">
					@if (loading$ | async) {
						<i class="ficon-spinner ficon-spin"></i>
					}
					<span translate="{{ data.isUnlinking ? 'modal-change-password_unlink-and-save' : 'modal-change-password_change-password' }}"></span>
				</button>
			</div>
		</form>
	</div>
</div>
